import { MiddleTruncatedText } from 'features/knowledgeDocumentViewer/components/MiddleTruncatedText'
import { AssetSearchItem } from 'features/knowledgeDocumentViewer/types/searchableItems'
import { FileText, Package } from 'lucide-react'
import React from 'react'
import styled from 'styled-components'

const CARD_WIDTH = 120
const ICON_AREA_HEIGHT = 100

const Card = styled.button<{ $isSelected?: boolean }>`
  display: flex;
  flex-direction: column;
  width: ${CARD_WIDTH}px;
  flex-shrink: 0;
  padding: 0.25rem;
  background: ${(props) =>
    props.$isSelected
      ? props.theme.forecast.activeButton
      : props.theme.forecast.defaultButton};
  border-radius: 0.25rem;
  overflow: hidden;
  cursor: pointer;
  text-align: left;
  border: 2px solid transparent;

  &:hover {
    background-color: ${(props) =>
      props.$isSelected
        ? props.theme.forecast.hoverGhostButton
        : props.theme.forecast.hoverButton};
  }
  &:active {
    background-color: ${(props) => props.theme.forecast.activeButton};
    color: ${(props) => props.theme.forecast.activeText};
  }
`

const IconArea = styled.div`
  width: 100%;
  height: ${ICON_AREA_HEIGHT}px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.375rem;
  background-color: ${(props) => props.theme.forecast.cardGroupBackground};
  color: ${(props) => props.theme.forecast.secondaryText};
`

const AssetTypeBadge = styled.span`
  font-size: 0.5625rem;
  padding: 0.0625rem 0.375rem;
  border-radius: 0.125rem;
  background: ${(props) => props.theme.forecast.border};
  color: ${(props) => props.theme.forecast.defaultText};
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

const CardContent = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0.375rem 0.25rem 0 0.25rem;
  gap: 0.125rem;
`

const LinkedDocsRow = styled.div`
  display: flex;
  align-items: center;
  gap: 0.25rem;
  font-size: 0.5625rem;
  color: ${(props) => props.theme.forecast.secondaryText};
`

const Title = styled.div`
  font-size: 0.6875rem;
  font-weight: 500;
  color: ${(props) => props.theme.forecast.defaultText};
`

interface RecentAssetCardProps {
  asset: AssetSearchItem
  isSelected?: boolean
  onClick: (asset: AssetSearchItem, event?: React.MouseEvent) => void
}

export const RecentAssetCard: React.FC<RecentAssetCardProps> = ({
  asset,
  isSelected = false,
  onClick,
}) => {
  const handleClick = (event: React.MouseEvent) => {
    onClick(asset, event)
  }

  return (
    <Card onClick={handleClick} $isSelected={isSelected}>
      <IconArea>
        <Package size={28} />
        {asset.assetType && <AssetTypeBadge>{asset.assetType}</AssetTypeBadge>}
      </IconArea>
      <CardContent>
        {asset.linkedDocumentCount > 0 && (
          <LinkedDocsRow>
            <FileText size={10} />
            {asset.linkedDocumentCount}
          </LinkedDocsRow>
        )}
        <Title>
          <MiddleTruncatedText
            text={asset.displayName}
            maxWidth='100%'
            fillWidth
            tooltipFontSize='0.6875rem'
          />
        </Title>
      </CardContent>
    </Card>
  )
}
